import { CurriculumCountryCodes } from '~/curriculum/constants/curriculum.const'

/** PostHog flag for the 2026 back-to-school promo: badges, price-page discounts and the reactivation coupon. */
export const BACK_TO_SCHOOL_2026_FLAG = 'back-to-school-2026'

export interface BackToSchoolGeoOffer {
  percent: number
  price: string
  /** Undiscounted price the badge strikes through, where confirmed. */
  fullPrice?: string
  /** `price` split so the badge can size amount and period separately. */
  priceAmount?: string
  pricePeriod?: string
}

// The badge's numbers are properties of the visitor's geo location, not the site language
export const BACK_TO_SCHOOL_2026_BY_GEO: Record<string, BackToSchoolGeoOffer> = {
  [CurriculumCountryCodes.NORWAY.toUpperCase()]: {
    percent: 72,
    price: '49 kr/mnd',
    priceAmount: '49 kr',
    pricePeriod: '/mnd',
  },
  [CurriculumCountryCodes.USA.toUpperCase()]: {
    percent: 60,
    price: '$7/mo',
    fullPrice: '$18',
    priceAmount: '$7',
    pricePeriod: '/mo',
  },
}
